import { useCallback, useEffect, useState } from "react"

import izenuAPI from "../../../services/izenuAPI";

export default function UpdatePwd({ id, show, setShow }) {

    const [activity, setActivity] = useState(false);
    const [view, setView] = useState(show);
    const [pwd1, setPwd1] = useState("");

    const validateFields = useCallback(() => {

        if (pwd1.length <= 3) {
            alert("Palavra passe muito curta");
            return false;
        } else {
            return true;
        }


    }, [pwd1]);
    const updatePwd = useCallback(async () => {

        if (!validateFields()) {
            return;
        }
        setActivity(true);

        const data = {
            user_id: id,
            pwd: pwd1
        }

        try {
            const { data: r } = await izenuAPI.post("/browser/artist/updatePassword.php", data);

            if (r.response) {
                alert("Palavra passe actualizada com sucesso!");
            } else {
                alert("Não foi possivel actualizar, tente mais tarde!");
            }
            setShow(false);
            setActivity(false);

        } catch (error) {
            alert("Não foi possivel actualizar, tente mais tarde!");
            setShow(false);
            setActivity(false);
        }
        setShow(false);
        setActivity(false);
    }, [id, pwd1]);


    if (!show) {
        return <></>;
    } else {
        return (
            <div className='absolute h-full z-100 left-0 top-0 w-full bg-gray-500/50 flex justify-center items-start'>
                <div className='shadow-lg relative flex mt-20 flex-col gap-10 p-5 rounded-md shadow-gray-500/50 bg-gray-50 w-3/5'>
                    <form onSubmit={(e) => {
                        e.preventDefault();

                        updatePwd();
                    }} class="w-full">
                        <div class="mb-5">
                            <div className="flex flex-row justify-between items-center">
                                <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Nova palavra passe</label>
                                <button type="button" className="" onClick={() => setShow(false)}>
                                    <span>X</span>
                                </button>
                            </div>

                            <input type="text" onChange={(e) => {
                                setPwd1(e.target.value);
                            }} required id="password" placeholder="Introduz a nova palavra passe" class="shadow-xs bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-xs-light" />

                        </div>

                        <button type="submit" class="text-gray-50 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Actualizar palavra passe</button>
                        {activity ? (
                            <div className="absolute left-0 top-0  w-full h-full bg-gray-600/50 flex flex-col justify-center items-center">
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin text-amber-400 fill-amber-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                </svg>
                                <span className="text-gray-50">A actualizar...</span>
                            </div>
                        ) : (
                            <></>
                        )}

                    </form>
                </div>
            </div>
        )
    }


}

